import * as types from './../constants/actionTypes';
import initialState from './initialState';
import { findIndex } from 'lodash';

export default function (state = initialState.shops, action) {
   switch (action.type) {
      case types.GET_ALL_SHOPS_SUCCESS:
         return action.payload.shops;
      case types.CREATE_SHOP_SUCCESS: {
         return [].concat(state, action.payload.shop);
      }
      //Categories
      case types.CREATE_CATEGORY_SUCCESS: {
         const shopIndexForCategory = findIndex(state, function (shop) {
            return shop.id === action.payload.shopId;
         });
         return [
            ...state.slice(0, shopIndexForCategory),
            Object.assign({}, state[shopIndexForCategory], {
               categories: [].concat(
                  state[shopIndexForCategory].categories
                     ? state[shopIndexForCategory].categories : [],
                  action.payload.category)
            }),
            ...
               state.slice(shopIndexForCategory + 1)
         ];
      }
      //SubCategories
      case types.CREATE_SUB_CATEGORY_SUCCESS: {
         const shopIndex = findIndex(state, function (shop) {
            return shop.id === action.payload.shopId;
         });
         const categoryIndex = findIndex(state[shopIndex].categories, (category) => (
            category.id === action.payload.categoryId
         ));

         const subCategories = state[shopIndex].categories[categoryIndex].subCategories
            ? state[shopIndex].categories[categoryIndex].subCategories :
            [];
         const newSubCategories = [].concat(subCategories, action.payload.subCategory);
         const newCategories =
            Object.assign(
               {},
               state[shopIndex].categories[categoryIndex],
               {
                  subCategories: newSubCategories
               });
         const newCategoriesArray = [
            ...state[shopIndex].categories.slice(0, categoryIndex),
            newCategories,
            ...state[shopIndex].categories.slice(categoryIndex + 1)
         ];
         const newShop = Object.assign({}, state[shopIndex], {
            categories: newCategoriesArray
         });
         return [
            ...state.slice(0, shopIndex),
            newShop,
            ...state.slice(shopIndex + 1)
         ];
      }

      default:
         return state;
   }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/shopReducers.js
 **/